import React, { useState } from "react";

import { CBadge, CListGroup, CListGroupItem, CButton } from "@coreui/react";
import { useSelector } from "react-redux";

import URL from "../../../../config/api";
import axios from "../../../../config/axios";
import { elementToPDF } from "../../../../utils/export";
import LoadingStatistics from "../../../LoadingStatistics";
import StatisticFiltersCompare from "../../../StatisticFiltersCompare";
import TextEditorReadOnly from "../../../TextEditorReadOnly/TextEditorReadOnly";

export default function DataQFiltro({
  list,
  applications,
  user,
  activity_id: activityId,
  printStatistic
}) {
  const token = useSelector(state => state.user.token);

  const [groupId, setGroupId] = useState(0);
  const [regionId, setRegionId] = useState(0);
  const [schoolId, setSchoolId] = useState(0);
  const [roomId, setRoomId] = useState(0);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const changeFilter = selected => {
    setLoading(true);
    setRoomId(selected.roomId);
    setGroupId(selected.groupId);
    setRegionId(selected.regionId);
    setSchoolId(selected.schoolId);

    const params = {
      group_id: selected.groupId,
      region_id: selected.regionId,
      school_id: selected.schoolId,
      room_id: selected.roomId,
      activity_id: activityId
    };

    axios
      .get(`${URL.api}statistics/evaluation_descriptor_distractor`, {
        params,
        headers: { authorization: `Bearer ${token}` }
      })
      .then(resp => {
        setData(resp.data.data);
        setLoading(false);
      });
  };

  const getOptionPercentage = (question, option) => {
    const checkedTotal = question.options.reduce(
      (acc, val) => acc + val.checked_by,
      0
    );

    if (checkedTotal === 0) {
      return 0;
    }

    return (option.checked_by / checkedTotal) * 100;
  };

  const isDistractor = (question, option) => {
    const distractorValue = question.options.reduce(
      (acc, val) => Math.max(acc, val.check_value ? 0 : val.checked_by),
      0
    );

    if (distractorValue > 0 && distractorValue === option.checked_by)
      return true;

    return false;
  };

  return (
    <div className="d-flex flex-column align-items-center w-100">
      <div className="layoutTabelaComparacao flex-column w-100">
        <StatisticFiltersCompare
          activityId={activityId}
          onChange={changeFilter}
          hideUser
        />
      </div>
      <div className="w-100">
        {loading ? (
          <LoadingStatistics />
        ) : (
          data && (
            <div className="w-100">
              <div className="d-flex w-100 justify-content-end">
                <CButton
                  id="printBtn"
                  color="link"
                  className="text-muted p-0"
                  size="sm"
                  onClick={() =>
                    elementToPDF("toPrint", "Descritor e Distrator.pdf")
                  }
                >
                  <i className="fa fa-file-pdf-o  mr-2"></i> Exportar para PDF
                </CButton>
              </div>
              <div className="w-100" id="toPrint">
                {data.questions.map(question => (
                  <div className="p-4 w-100" key={question.id}>
                    <p>
                      <TextEditorReadOnly
                        editorType={{ name: "description", id: 1 }}
                        questionId={question.id}
                        textContent={question.description}
                      />
                      <CBadge
                        color="secondary"
                        className="p-2 w-100 text-left"
                        style={{ whiteSpace: "normal" }}
                      >
                        {question.ability_description}
                      </CBadge>
                    </p>
                    <CListGroup>
                      {question.options.map(option => (
                        <CListGroupItem
                          className={
                            option.check_value
                              ? "bg-primary"
                              : isDistractor(question, option)
                              ? "list-group-item-warning"
                              : ""
                          }
                          key={option.id}
                          style={{ marginTop: "1px" }}
                        >
                          <TextEditorReadOnly
                            editorType={{ name: "description", id: 1 }}
                            questionId={option.id}
                            textContent={option.description}
                            style={{ margin: 0 }}
                          />
                          A porcentagem de estudantes que marcaram essa
                          alternativa foi de:{" "}
                          <strong>
                            {getOptionPercentage(question, option).toFixed(2)}%
                          </strong>
                        </CListGroupItem>
                      ))}
                    </CListGroup>
                  </div>
                ))}
              </div>
            </div>
          )
        )}
      </div>
    </div>
  );
}
